import React, { useEffect } from 'react';
import { useTracking, trackingContext, useTrackingContext } from '@jbhi-fi/components/src/Tracking';
import { JBButton, JBTypography } from '@jbhi-fi/lanyard-ui';

const LockedOutView = (): JSX.Element => {
  const { tracker } = useTracking({
    context: trackingContext.modal,
    group: 'too many attempts',
    category: useTrackingContext().tracker.category,
  });

  useEffect(() => {
    document.title = 'Verification attempts reached - Account - JB Hi-Fi';

    tracker.trackView();
    tracker.trackError({ errorMsg: "Oops you've tried too many times", contextOverride: trackingContext.form });
  }, []);

  const handleClick = (): void => {
    tracker.trackClick({ label: 'go to my account' });
    window.location.href = '/account#/';
  };

  return (
    <div className="page-width verify-section">
      <JBTypography type="h2" margin="20px 0px 24px">
        Oops you've tried too many times...
      </JBTypography>
      <JBTypography type="p">
        You can try again in 24 hours in the ‘Manage account’ section to link up your in-store receipts.
      </JBTypography>
      <JBTypography align="center" type="p" margin="40px 0px 0px">
        <JBButton type="primary" label="Go to My Account" onClick={handleClick} fullWidth />
      </JBTypography>
    </div>
  );
};

export default LockedOutView;
